import * as Styles from "./styles/MyAccountContainerStyles";
import { Button, ButtonGroup, ClickAwayListener, Grid, Grow, MenuItem, MenuList, Paper, Popper } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useSnackbar } from "notistack";
import React from "react";
import { UpdateBidConfirmationSetting } from "../../services/BidderService";
import { LoadingComponent } from "../loading/LoadingComponent";
import { AppContext } from "../../contexts/AppContext";

export const BiddingPreferences: React.FC = () => {
  const classes = Styles.MyAccountContainerStyles();
  const { enqueueSnackbar } = useSnackbar();
  const context = React.useContext(AppContext);

  const anchorRef = React.useRef(null);
  const [confirmationSetting, setConfirmationSetting] = React.useState(context.bidderState.bidder.bidConfirmationSetting);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setConfirmationSetting(context.bidderState.bidder.bidConfirmationSetting);
    setLoading(false);
  }, [context.bidderState.bidderLoaded])

  const options = {
    enable: { value: 0, label: 'Enable' },
    disable: { value: 1, label: 'Disable' },
    enableExcLastHour: { value: 2, label: 'Enable (Excl. Last Hour)' }
  };

  function handleToggle() {
    setOpen(prevOpen => !prevOpen);
  };

  const handleChange = (event: any, val: number) => {
    setConfirmationSetting(val);
    setOpen(false);
  };

  const save = () => {
    setLoading(true);
    UpdateBidConfirmationSetting(confirmationSetting!).then(() => {
      enqueueSnackbar("Your bidding preferences have been saved.", { variant: "success" });
    }).catch((err) => {
      enqueueSnackbar("There was a problem saving your preferences. Please try again later.", { variant: "error" });
    }).finally(() => {
      setLoading(false);
      context.bidderState.bidder.bidConfirmationSetting = confirmationSetting;
    });
  };

  return (
    <Grid container>
      {loading && (
        <Grid item xs={12}>
          <LoadingComponent label={"Saving preferences..."} marginTop="50px" />
        </Grid>
      )}

      {!loading && (
        <>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <ButtonGroup
              size="medium"
              variant={"outlined"}
              color={"default"}
              ref={anchorRef}
              style={{ height: "100%", backgroundColor: "white", width: "100%" }}
            >
              <Button onClick={handleToggle} style={{ flexGrow: 1, justifyContent: "flex-start", textAlign: "left" }}>
                {Object.values(options).find(option => option.value === confirmationSetting)?.label || 'Select an option'}
              </Button>
              <Button
                color={"default"}
                size="small"
                aria-owns={open ? "menu-list-grow" : ""}
                aria-haspopup="true"
                onClick={handleToggle}
                style={{ flexGrow: 0 }}
              >
                <ExpandMoreIcon />
              </Button>
            </ButtonGroup>
            <Popper className={classes.searchOptionList} open={open} anchorEl={anchorRef.current} transition disablePortal>
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin: placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <Paper id="menu-list-grow">
                    <ClickAwayListener onClickAway={() => { setOpen(false) }}>
                      <MenuList>
                        {Object.values(options).map(option => (
                          <MenuItem key={option.value} style={{ textTransform: 'uppercase' }} onClick={event => handleChange(event, option.value)}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </Grid>

          <Grid item container xs={12} justifyContent="center"  className={classes.saveButtonContainer}>
            <Button color="primary" variant="contained" onClick={save}>
              Save Settings
            </Button>
          </Grid>
        </>
      )}
    </Grid>
  );
};
